// Bridge the (sync) react-mde command API to the (async) modal picking flow,
// exactly like FM/articles/embed/Command/actions. asyncDailymotion() opens the
// modal and resolves once the user picks a video (embed code) or closes (null).
import EventEmitter from 'events';

const myEmitter = new EventEmitter();

export function asyncDailymotion() {
  return function(dispatch) {
    dispatch({ type: 'EDITOR_OPEN_DAILYMOTION' });

    // `.once`: the listener auto-removes after closeDailymotion fires, so no
    // listener leak (unlike embed's `.on`). One command click = one listener,
    // and the modal always resolves via closeDailymotion (pick or Dialog close).
    return new Promise(resolve => {
      myEmitter.once('closeDailymotion', resolve);
    });
  };
}

export function closeDailymotion(response) {
  myEmitter.emit('closeDailymotion', response);

  return {
    type: 'EDITOR_CLOSE_DAILYMOTION',
    payload: { response },
  };
}
